import ZtServiceFactory from '@src/services/zt';
import qs from '@xfe-team/utils/src/query-string-util';
import { useEffect } from 'react';

class BaseStore {
  $history;
  /**
   * store中初始化service接口变量
   */
  $ztService = ZtServiceFactory.getDefaultInstance();

  $props;

  /**
   * 跳转至具体的路由
   * @param {string} url - 跳转路由地址
   * @param {boolean} [isReplace] - 是否替换
   */
  redirect(url, isReplace = false) {
    if (isReplace) {
      this.$history.replace(url);
    } else {
      this.$history.push(url);
    }
  }

  /**
   * 创建 search params 参数
   * @private
   */
  _createSearchParams() {
    let { search = '' } = this.$history.location;
    search = search.replace(/^\?/, '');
    useEffect(
      () => {
        if (search) {
          this.$searchParams = qs.parse(search);
        } else {
          this.$searchParams = {};
        }
      },
      [search]
    );
  }

  use(props) {
    // this.$props = props || {};
    // this.$history = useHistory();
    // /**
    //  * 路由参数
    //  * @type {History}
    //  */
    // this.$routeParams = useParams();
    // this.$routeMatch = useRouteMatch();
    // this._createSearchParams();
  }
}

export default BaseStore;
